import React from 'react';

const Lpdominio = ({ 
  headline, 
  subheadline, 
  domainName, 
  email, 
  telefone,
  backgroundColor = '#121212',
  textColor = '#F5F5F5',
  accentColor = '#D4AF37' 
}) => {
  
  // --- INÍCIO DAS MODIFICAÇÕES ---
  const isSpecialDomain = domainName === 'comoaposentar.com.br';

  const specialContent = {
    headline: "Reservado para quem é autoridade no assunto",
    subheadline: "Este não é apenas um domínio. É a base para o futuro da educação e do planejamento para aposentadoria no Brasil. Um ativo digital definitivo, esperando pela instituição com a credibilidade e a visão para desenvolvê-lo",
    contactIntro: "Para discutir o futuro deste ativo digital, fale com:",
    contactName: "Alexandre França", 
    contactEmail: "dominios@af3.com.br", 
  };
  // --- FIM DAS MODIFICAÇÕES ---

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor,
      color: textColor,
      fontFamily: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
      textAlign: 'center',
      padding: '3rem 1.5rem',
      transition: 'all 0.4s ease',
      backgroundImage: backgroundColor === '#121212' 
        ? 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.04), transparent 70%)'
        : 'radial-gradient(circle at 30% 20%, rgba(0,0,0,0.03), transparent 70%)',
    },
    headline: {
      fontSize: 'clamp(2.2rem, 5vw, 4rem)',
      fontWeight: '700',
      lineHeight: '1.2',
      letterSpacing: '-0.015em',
      maxWidth: '24ch',
      marginBottom: '1.25rem',
    },
    subheadline: {
      fontSize: 'clamp(1.1rem, 2.3vw, 1.6rem)',
      fontWeight: '400',
      opacity: '0.85',
      lineHeight: '1.6',
      maxWidth: '40ch',
      marginBottom: '3rem',
    },
    saleStatement: {
      fontSize: '1.05rem',
      fontWeight: '400',
      opacity: '0.9',
      marginBottom: '0.75rem',
    },
    domainName: {
      fontWeight: '700',
      color: accentColor,
      fontSize: '1.15rem',
    },
    contactSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.5rem',
      marginTop: '3rem',
    },
    contactInfo: {
      textAlign: 'center',
    },
    contactIntro: {
      fontSize: '0.95rem',
      fontWeight: '300',
      opacity: '0.65',
      marginBottom: '1rem',
    },
    contactName: {
      color: textColor,
      fontSize: '1.25rem',
      fontWeight: '700',
      marginBottom: '0.3rem',
    },
    contactLink: {
      color: accentColor,
      textDecoration: 'none',
      fontSize: '1.25rem',
      fontWeight: '500',
      display: 'block',
      margin: '0.3rem 0',
      transition: 'opacity 0.25s ease, transform 0.2s ease',
    },
    contactLinkHover: {
      opacity: 0.85,
      transform: 'scale(1.02)',
    },
    whatsappButton: {
      backgroundColor: '#25D366',
      color: '#FFFFFF',
      textDecoration: 'none',
      fontSize: '1.25rem',
      fontWeight: '700',
      padding: '0.75rem 2rem',
      borderRadius: '50px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      marginTop: '0.5rem', // Ajustei para ficar mais próximo
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    },
    whatsappButtonHover: {
      transform: 'scale(1.05)',
      boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)',
    },
    qrCodeWrapper: {
      padding: '10px',
      backgroundColor: backgroundColor.startsWith('#F') ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.05)',
      borderRadius: '16px',
      boxShadow: backgroundColor === '#121212' 
        ? '0 4px 12px rgba(0, 0, 0, 0.3)'
        : '0 4px 10px rgba(0, 0, 0, 0.1)',
      backdropFilter: 'blur(4px)',
    },
    qrCodeImage: {
      width: '140px',
      height: '140px',
      display: 'block',
      borderRadius: '8px',
    }
  };

return (
  <div style={styles.container}>
    <h1 style={styles.headline}>
      {isSpecialDomain ? specialContent.headline : headline}
    </h1>
    <p style={styles.subheadline}>
      {isSpecialDomain ? specialContent.subheadline : subheadline}
    </p>
    
    {!isSpecialDomain && (
      <div style={{ maxWidth: '650px', margin: '0 auto' }}>
        {/* REMOVIDO: <p> vazio que estava aqui */}
        <p style={{
          ...styles.saleStatement, 
          marginTop: '1.2rem', 
          opacity: 0.85, 
          lineHeight: '1.5',
          fontWeight: '300' 
        }}>
          {/* DICA: Se quiser trazer do banco, troque o texto abaixo por {saleDescription} */}
          Uma oportunidade exclusiva para consolidação de autoridade, lançamento de produtos financeiros ou proteção de marca institucional. Ativos com este posicionamento são únicos e definitivos.
        </p>
      </div>
    )}

    <div style={styles.contactSection}>
      <div style={styles.contactInfo}>
     
        {isSpecialDomain ? (
          <div>
            <p style={styles.contactName}>{specialContent.contactName}</p>
            <a 
              href={`mailto:${specialContent.contactEmail}`} 
              style={styles.contactLink}
            >
              {specialContent.contactEmail}
            </a>
          </div>
        ) : (
          /* Adicionado display block nas tags <a> caso seus styles.contactLink já não tenham, 
             garantindo que o e-mail fique em cima e o telefone embaixo como na imagem */
          <div>
            <a 
              href={`mailto:${email}`} 
              style={{ ...styles.contactLink, display: 'block' }}
              onMouseOver={e => Object.assign(e.target.style, styles.contactLinkHover)}
              onMouseOut={e => Object.assign(e.target.style, { transform: 'scale(1)', opacity: 1 })}
            >
              {email}
            </a>          
            
            {telefone && (
              <a
                href={`https://wa.me/${telefone.replace(/\D/g, '')}?text=Olá,%20tenho%20interesse%20no%20domínio%20${domainName}.`}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.whatsappButton}
                onMouseOver={e => Object.assign(e.target.style, styles.whatsappButtonHover)}
                onMouseOut={e => Object.assign(e.target.style, { transform: 'scale(1)', boxShadow: 'none' })}
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                  alt="Ícone do WhatsApp" 
                  style={{ height: '24px', marginRight: '8px' }} 
                />
                Consultar
              </a>
            )}
          </div>
        )}
      </div>
      
      {!isSpecialDomain && (
        <div style={styles.qrCodeWrapper}>
          <img
            src="/qr_whats.png"
            alt="QR Code para Contato"
            style={styles.qrCodeImage}
          />
        </div>
      )}
    </div>
  </div>
);
};

export default Lpdominio;
